// Trustpilot brand colors and constants
export const TP_GREEN = '#00b67a';
export const TP_BLACK = '#191919';
export const TP_GRAY = '#717171';
export const TP_LIGHT_GRAY = '#e6e6e6';
export const TP_BG = '#f5f5f5';
export const TRUSTPILOT_CDN = 'https://cdn.trustpilot.net/brand-assets/4.1.0';
export const TRUSTPILOT_REVIEW_URL = 'https://www.trustpilot.com/review/stanorai.com';
// Trustpilot official star SVG URLs
export const getStarSvg = (rating) => {
    const ratingMap = {
        1: 'stars-1',
        1.5: 'stars-1.5',
        2: 'stars-2',
        2.5: 'stars-2.5',
        3: 'stars-3',
        3.5: 'stars-3.5',
        4: 'stars-4',
        4.5: 'stars-4.5',
        5: 'stars-5'
    };
    return `${TRUSTPILOT_CDN}/stars/${ratingMap[rating] || 'stars-5'}.svg`;
};
export const getTrustpilotLogo = (variant = 'black') => {
    return `${TRUSTPILOT_CDN}/logo-${variant}.svg`;
};
